<template>
    <div>
        <div class="flex" >
            <div><a-button class="top_btn" type="primary"   @click="exportList()"  >
                批量导出
            </a-button>
                <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template></span></div>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id" @change="handleChange" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" >
            <span slot="list_order" slot-scope="text, record">
        <a-input placeholder=" " v-model="record.list_order" class="inputs" size="small"/>
            </span>
            <span slot="action" slot-scope="text, record">
                <a @click="gotoStatistics(record)">查看 </a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm([record.id])"
                  @cancel="()=>{}"
          >
   <a  v-has="'btn_delete'">删除</a>
  </a-popconfirm>
      </span>
        </a-table>

    </div>

</template>

<script>
    import API from "../api";
    import {changStatus, removeById,orderList} from "../../../../utils/utils"
    const columns = [

        {
            title: "联系人",
            key: "name",
            width:"150px",
            dataIndex: "name",
        },
        {
            title: "邮箱",
            key: "email",
            ellipsis: true,
            width:"150px",
            dataIndex: "email",
        },
        {
            title: "询盘内容",
            key: "content",
            ellipsis: true,
            width:"200px",
            dataIndex: "content",
        },
        {
            title: "国家",
            key: "country",
            ellipsis: true,
            dataIndex: "country",
        },
        {
            title: "询盘来源",
            key: "source_name",
            ellipsis: true,
            dataIndex: "source_name",
        },
        {
            title: "询盘时间",
            key: "create_time",
            ellipsis: true,
            dataIndex: "create_time",
        },
        {
            title: "跟进人",
            key: "nickname",
            ellipsis: true,
            dataIndex: "nickname",
        },
    ];
    export default {
        name: 'inquiry',
        data() {
            return {
                id: this.$route.query.id,
                visibleForm: false,
                titleForm: "",
                loading: true,
                editId: null,
                data: [],
                selectedRowKeys: [], // Check here to configure the default column
                columns,

                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/WebStatistics"; //设置左侧导航2-2 active
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
            handleChange(pagination, filters, sorter) {
                // this.filteredInfo = filters;
                // this.sortedInfo = sorter;
            },
            gotoStatistics(row){
                this.$router.push(`/DataStatistics/WebStatisticsDetails?id=${row.id}`)
            },
            exportList(){
                API.service.INQUIRY_EXPORT( { ids:this.selectedRowKeys,id:this.id} ).then(res => {
                    window.open( `${this.$store.state.urlExper}${res.data.data.path.substr(1)}`  )
                })
            },
            getList(page) {
                API.service.INQUIRY_GET_LIST({page:page||1,id:this.id}).then(res => {
                    this.selectedRowKeys=[]
                    this.data = res.data.data.data
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.selectedRowKeys=[]
                    this.loading = false
                })
            },
            confirm(id) {
                if(id=='all'){
                    id=this.selectedRowKeys
                }
                removeById( API.service.DELE,id).then(res => {
                    if (res == true) {
                        this.getList()
                        this.selectedRowKeys=[]
                    }
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
        },
        mounted() {
            this.getList()
        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
    .search-group {
        float: right;
    }
    .search-group .ant-input {
        width: 200px;
        margin: 0 8px 0 0 ;
    }
    .button-group {
        float: left;
    }
    #list_order {
        width: 50px;
    }
    .top .flex{ box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box;width: 60%;margin-bottom: 20px}
</style>
